import { Entity, ImageModel, Nullable } from '@hglobal/common';

import { User, UserGroup } from './user.model';
import { SlackMessageChannel } from './slack-channel.model';

export enum MessageCategory {
  LAndD = 'learning-and-development',
}

export enum MessageStatus {
  Scheduled = 'scheduled',
  Sent = 'sent',
}

export enum SlackBotOption {
  RedCoreTeam = 'slackBot',
  InterCom = 'slackBotIntercome',
}

export interface MessageBaseModel extends Entity {
  messageType: string;
  groups?: UserGroup[];
  slackChannels?: SlackMessageChannel[];
  images: ImageModel[];
  isScheduled: boolean;
  scheduledAt: string;
  status: MessageStatus;
  text?: string;
  botType?: SlackBotOption;
}

export interface MessageModel extends MessageBaseModel {
  author: User;
  createdAt: string;
  isEditable: boolean;
  sentAt: Nullable<string>;
}

export type MessageListModel = Omit<MessageModel, 'author' | 'createdAt'>;

export interface AdminMessageModel extends MessageModel {
  category: MessageCategory;
}
